/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DoctorDetails from './doctor-details';
import DoctorDetailsDetail from './doctor-details-detail';
import DoctorDetailsUpdate from './doctor-details-update';
import DoctorDetailsDeleteDialog from './doctor-details-delete-dialog';

const DoctorDetailsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DoctorDetails />} />
    <Route path="new" element={<DoctorDetailsUpdate />} />
    <Route path=":id">
      <Route index element={<DoctorDetailsDetail />} />
      <Route path="edit" element={<DoctorDetailsUpdate />} />
      <Route path="delete" element={<DoctorDetailsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DoctorDetailsRoutes;
